import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	TGetPublicAttachmentUploadInfoRequest,
	TPublicAttachmentUploadInfo,
	TUploadPublicAttachmentRequest,
} from './types';
import {
	getPublicAttachmentUploadInfoRequest,
	getPublicAttachmentUploadInfoSuccess,
	setPublicAttachmentUploadInfoError,
	uploadPublicAttachmentRequest,
	uploadPublicAttachmentSuccess,
	uploadPublicAttachmentFailure,
} from './reducer';

function* getPublicAttachmentUploadInfoWorker(
	action: PayloadAction<TGetPublicAttachmentUploadInfoRequest>,
) {
	try {
		const response: TPublicAttachmentUploadInfo = yield call(
			api.publicAttachment.getPublicAttachmentUploadInfo,
			action.payload.hash,
		);
		yield put(getPublicAttachmentUploadInfoSuccess(response));
	} catch (error) {
		const errorMessage = axios.isAxiosError(error)
			? (error?.response?.data?.message ?? 'Invalid or expired upload link')
			: 'Invalid or expired upload link';
		yield put(setPublicAttachmentUploadInfoError(errorMessage));
	}
}

function* uploadPublicAttachmentWorker(action: PayloadAction<TUploadPublicAttachmentRequest>) {
	try {
		yield call(api.publicAttachment.uploadPublicAttachment, action.payload);
		yield put(uploadPublicAttachmentSuccess());
		notificationContainer('File has been uploaded successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'Upload error',
				'error',
			);
		yield put(uploadPublicAttachmentFailure());
	}
}

export function* publicAttachmentSaga() {
	yield takeEvery(getPublicAttachmentUploadInfoRequest.type, getPublicAttachmentUploadInfoWorker);
	yield takeEvery(uploadPublicAttachmentRequest.type, uploadPublicAttachmentWorker);
}
